var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          model: {
            value: _vm.helpModalOpen,
            callback: function ($$v) {
              _vm.helpModalOpen = $$v
            },
            expression: "helpModalOpen",
          },
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("Help"),
          ]),
          _vm._v(" "),
          _c("h2", [
            _c("em", [
              _vm._v(_vm._s(_vm.transformNameToDisplayName(_vm.helpField))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alert alert-info" }, [
            _vm._v("\n            ISO 11179 help definition\n        "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-body" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.getHelpText(_vm.helpField)) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("span", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-info",
                on: {
                  click: function ($event) {
                    _vm.helpModalOpen = false
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-times",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" Close\n            "),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("api-errors", { attrs: { errors: _vm.getErrors } }),
      _vm._v(" "),
      _vm.loading
        ? _c("loading")
        : _vm.ready
        ? _c("div", { attrs: { id: "inventory" } }, [
            _c("div", { staticClass: "heading" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-12 clearfix" }, [
                  _c("a", { attrs: { href: "#inventory" } }, [
                    _vm._v("Show table & headers"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pull-right" }, [
                    _c("a", { attrs: { href: _vm.downloadCSVUrl } }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default",
                          attrs: { disabled: !_vm.tableDataExists },
                        },
                        [
                          _c("i", { staticClass: "fas fa-file-csv" }),
                          _vm._v(
                            "\n                                Download CSV\n                            "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("a", { attrs: { href: _vm.downloadExcelUrl } }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default",
                          attrs: { disabled: !_vm.tableDataExists },
                        },
                        [
                          _c("i", { staticClass: "fas fa-file-excel" }),
                          _vm._v(
                            "\n                                Download Excel File\n                            "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "btn-group",
                        staticStyle: { "margin-left": "10px" },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-default",
                            attrs: { href: _vm.cardViewUrl },
                          },
                          [
                            _c("i", {
                              staticClass: "glyphicon glyphicon-th-large",
                            }),
                            _vm._v(" Card View\n                            "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { disabled: "" },
                          },
                          [
                            _c("i", {
                              staticClass: "glyphicon glyphicon-th-list",
                            }),
                            _vm._v(" List View\n                            "),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "flex-grow": "1",
                  overflow: "hidden",
                  display: "flex",
                },
              },
              [
                _c("ve-table", {
                  attrs: {
                    columns: _vm.veColumns,
                    "table-data": _vm.veTableData,
                    "expand-option": _vm.expandOption,
                    "row-key-field-name": "rowKey",
                    "fixed-header": true,
                    "border-around": true,
                    "border-x": true,
                    "border-y": true,
                    "scroll-width": 0,
                    "row-style-option": _vm.rowStyleOption,
                    "column-width-resize-option": _vm.columnWidthResizeOption,
                    "max-height": "100%",
                    "max-width": "100%",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-pagination" },
              [
                _c(
                  "a",
                  { staticClass: "pull-left", attrs: { href: "#inventory" } },
                  [_vm._v("Show table & headers")]
                ),
                _vm._v(" "),
                _c("ve-pagination", {
                  attrs: {
                    layout: ["total", "prev", "pager", "next", "jumper"],
                    total: _vm.totalCount,
                    "page-index": _vm.pageIndex,
                    "page-size": _vm.pageSize,
                  },
                  on: { "on-page-number-change": _vm.pageNumberChange },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }